export default __webpack_public_path__ + "static/media/Manual.926bd849.mp3";